export default {
  process: {
    step1: 'Puzzle Settings',
    step2: 'Gameplay Settings',
    next: 'Next',
    previous: 'Previous',
    finish: 'Finish',
  },
  step1: {
    setting1: {
      title: 'Bottom Image',
      upload: 'Please upload the bottom image.',
    },
    setting2: {
      title: 'Puzzle Pieces',
      blockNum: 'Block Count',
      style: 'Puzzle Style',
      edgeStyle: 'Seam Style',
    },
    setting3: {
      title: 'Advanced Settings',
      border: 'Stroke',
      innerShadow: 'Inner Shadow',
      relief: 'Emboss',
      solidLine: 'Solid Line',
      dashLine: 'Dashed',
      lineWidth: 'Thickness',
      solidSegment: 'Dashed',
      blankSegment: 'Spacing',
      blur: 'Blur',
      topShadow: 'Highlight Color',
      bottomShadow: 'Shadow Color',
    },
  },
  step2: {
    title: 'Specific Gameplay Puzzle Pieces',
    titleTip:
      'Select special gameplay puzzle pieces, then choose puzzle pieces on the canvas to assign corresponding special logic.',
    addSpePuzzle: 'Add Specific Pieces',
    preview: 'Preview Style',
    closePreview: 'Close Preview',
    name: 'Name',
    placeholder: 'Enter',
    nameEmptyWarning: 'Name cannot be empty.',
    puzzleColor: 'Puzzle Color',
    lightBorder: 'Glow Stroke',
    lightInnerShadow: 'Glow Inner Shadow',
    blur: 'Blur',
  },
}
